import React from "react";
import { FiCamera, FiBell, FiBarChart2 } from "react-icons/fi"; // icons
import "./style.css";
import { useNavigate } from "react-router-dom";

export default function GettingStarted() {
  const navigate = useNavigate();

  const cards = [
    {
      title: "Connect Your Cameras",
      description:
        "To get started, go to ‘Cameras’ and add your first camera to begin monitoring.",
      buttonText: "Add Camera",
      icon: <FiCamera className="icon" size={40} />,
      path: "/camera",
    },
    {
      title: "Set Up Your Events",
      description:
        "Set up events to monitor productivity, attendance, and hygiene. Start by adding your first event in Events.",
      buttonText: "Set up Events",
      icon: <FiBell className="icon" size={40} />,
      path: "/usecase-events",
    },
    {
      title: "Get Updates",
      description:
        "Stay informed with regular updates on activities and performance, ensuring you never miss critical insights.",
      buttonText: "Track Event",
      icon: <FiBarChart2 className="icon" size={40} />,
      path: "/reports",
    },
  ];

  return (
    <div className="getting-started">
      <h1 className="heading">Getting Started with Monitoring</h1>
      <p className="subheading">
        A simple guide to get your monitoring up and running.
      </p>

      <div className="cards-container">
        {cards.map((card, idx) => (
          <div className="card" key={idx}>
            <div className="icon-placeholder">{card.icon}</div>
            <h2 className="card-title">{card.title}</h2>
            <p className="card-desc">{card.description}</p>
            <button className="primary-btn" onClick={() => navigate(card.path)}>
              {card.buttonText}
            </button>{" "}
          </div>
        ))}
      </div>
    </div>
  );
}
